import Vue from "vue";

Vue.filter("timeValue", function(value) {
  return getTimeValue(value);
});




